import { Swords, Box, Users, ShieldCheck, Code2, Sparkles, Library } from "lucide-react";

export const ROADMAP = [
  { phase: "Phase 1", status: "live", icon: Library, title: "Custom card library", body: "Accounts, creator profiles, single & bulk card uploads, custom sets, card-back library and search." },
  { phase: "Phase 2", status: "live", icon: Swords, title: "Deck builder", body: "Commander, 60-card constructed and custom formats. Custom-only, official-only or hybrid decks with stats, zones and card backs." },
  { phase: "Phase 2", status: "live", icon: Sparkles, title: "Official cards via Scryfall", body: "A separate, clearly-labelled section for official Magic cards sourced from the Scryfall API." },
  { phase: "Phase 4", status: "planned", icon: Box, title: "Tabletop Simulator importer", body: "The deck manifest API is available. The separate Lua importer still needs to be built and verified inside TTS." },
  { phase: "Phase 5", status: "planned", icon: Users, title: "Communities & leagues", body: "Applications reviewed by impartial staff, second-review escalation, Verified Community and Verified League designations." },
  { phase: "Phase 6", status: "planned", icon: ShieldCheck, title: "Moderation", body: "Reports for cards, decks, card backs, profiles and communities with notifications, appeals and removal procedures." },
  { phase: "Phase 7", status: "planned", icon: Code2, title: "Open developer API", body: "Third-party app authorization, scoped tokens and per-client rate limits for card creator programs." },
];

export function RoadmapSection({ compact = false }) {
  const items = compact ? ROADMAP.filter((r) => r.status !== "live") : ROADMAP;
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3" data-testid="roadmap-section">
      {items.map((r) => {
        const live = r.status === "live";
        return (
          <article
            key={r.title}
            aria-label={`${r.phase}: ${r.title} (${live ? "available now" : "not yet available"})`}
            className={`relative cursor-default select-none rounded-xl border p-6 ${live ? "border-amber-600/50 bg-amber-500/5" : "border-[#2A3447] bg-[#121620]/60"}`}
            data-testid={`roadmap-item-${r.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
          >
            <div className="mb-4 flex items-center justify-between">
              <r.icon className={`h-5 w-5 ${live ? "text-amber-400" : "text-slate-500"}`} aria-hidden />
              <span className={`rounded px-2 py-0.5 font-mono text-[10px] uppercase tracking-widest ${live ? "bg-emerald-950/80 text-emerald-300" : "bg-slate-800/80 text-slate-400"}`}>
                {r.phase} · {live ? "Live" : "Under construction"}
              </span>
            </div>
            <h3 className={`font-heading text-lg ${live ? "text-amber-100" : "text-slate-300"}`}>{r.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-slate-400">{r.body}</p>
          </article>
        );
      })}
    </div>
  );
}
